import { ACTION_STATUS, TASKS } from "./actions";

export const ACTION_VIEW_MODE = {
  new: "new",
  edit: "edit",
  view: "view",
};

export const ACTION_INPUT_VARIANT = {
  suggested: ACTION_STATUS.suggested,
  performed: ACTION_STATUS.performed,
};

export const TASK_INPUT_NAMES = {
  [TASKS.watering]: "waterAction",
  [TASKS.drug]: "drugAction",
  [TASKS.fertilize]: "fertilizeAction",
  [TASKS.diagnose]: "diagnoseAction",
  [TASKS.other]: "otherAction",
  [TASKS.observation]: "observationAction",
};
